import React, { Component } from 'react';

export default class QuestionPage extends Component {

    state = {
        duration: 10,
        timeLeft: 10,
        started: false,
    }

    Start(cb){
        const timer = setInterval(()=>{
            let t = this.state.timeLeft - 0.05;
            if(t <= 0){
                t= 0;
                clearInterval(timer); 
                cb();              
            }
            this.setState({timeLeft: t});
        },50);
    }
    
    componentDidUpdate(){
        const {duration, startCount, callBack} = this.props;
              
        if(!this.state.started && startCount){
            this.setState({duration:duration, timeLeft:duration,started:true});
            this.Start(callBack);
        }
    }

    render(){
        // const radius = 14;
        // const timerSize = radius*2 + 2;
        // const dashArray = 2*Math.PI*radius;
        // const dashOffset = dashArray - this.state.timeLeft / this.state.duration  * dashArray;
        // console.log("d o: " + dashOffset);

        const ratio = this.state.timeLeft / this.state.duration;
        const t = Math.pow(Math.sin(Math.PI*(3*ratio + 0.5)), 4);
        const timerOpacity = 0.3 + 0.4*t;

        const renderTime = this.state.started && this.state.timeLeft > 0;

        return <div style={{opacity: timerOpacity}}>
            {renderTime && <div style={{
                position:"absolute",
                right: 55,
                bottom: 34,
                textAlign:'right',
                fontSize: 16,
                fontWeight: 800,
                color: global.colorTheme.grey,
            }}>זמן קריאה</div>}


            {/* {renderTime && <div id="timer" style={{
                position:"absolute",
                right: 30,
                bottom: 30,
                width: timerSize,
                height: timerSize,
                textAlign: "center",
            }}> */}

            {renderTime && <div style={{
                position:"absolute",
                right: 24,
                bottom: 28,
                fontSize: 24,
                color: global.colorTheme.grey,
                transform: `rotate(${90}deg)`,
            }}>⋈</div>}

                {/* <div style={{
                    width: timerSize,
                    height: timerSize,
                    fontFamily: "monospace",
                    fontSize: 16,
                    display: "inline-block",
                    lineHeight: timerSize + "px",
                    color: global.colorTheme.grey,
                }}>{Math.round(this.state.timeLeft)}</div>
                <svg style={{
                    position:"absolute",
                    bottom:0,
                    left:0,
                    width: timerSize,
                    height: timerSize,
                    transform: "rotateY(-180deg) rotateZ(-90deg)",
                }}>
                    <circle r={radius} cx={timerSize/2} cy={timerSize/2} style={{
                        strokeDasharray: dashArray,
                        strokeDashoffset: dashOffset,
                        strokeLinecap: "square",
                        strokeWidth: "2px",
                        stroke: global.colorTheme.grey,
                        fill: "none",
                    }}></circle>
                </svg>               */}
            {/* </div>} */}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/Comp/Shared/Timer.js